import { Text } from '../../cdl/Text/Text';
import { formatNumber } from '../../common/helpers/formatNumber.helper';
import { Characters } from '../../common/helpers/unicode.helper';
import { Box } from '../../common/ui/Box';

import { DemandNumber } from './DemandNumber';
import { DemandVolume } from './DemandVolume';

const getColor = (value?: number) => {
    if (value === undefined || value === 0) {
        return 'foreground.subtle';
    }
    return value > 0 ? 'positive.foreground' : 'negative.foreground';
};

const getSign = (value: number) => {
    if (value === 0) {
        return '';
    }
    return value > 0 ? '+' : Characters.MINUS;
};

interface DemandDeltaProps {
    deltaVolume: number;
    deltaPercent?: number;
}

export const DemandDelta = ({ deltaVolume, deltaPercent }: DemandDeltaProps) => (
    <Box display="flex" flexDirection="column" alignItems="flex-end">
        <Text variant="small" color={getColor(deltaVolume)}>
            <DemandNumber>
                {getSign(deltaVolume)}
                <DemandVolume volume={Math.abs(deltaVolume)} />
            </DemandNumber>
        </Text>
        <Text variant="extraSmall" color="foreground.subtle">
            <DemandNumber>
                {deltaPercent === undefined
                    ? Characters.EN_DASH
                    : `${getSign(deltaPercent)}${formatNumber({ number: Math.abs(deltaPercent), maximumFractionDigits: 2 })}%`}
            </DemandNumber>
        </Text>
    </Box>
);
